module.exports = __webpack_public_path__ + "img/icon-3.4700bfb7.png";